// src/pages/Services.jsx
import React from "react";
import Section from "../components/Section";
import { SERVICES, BUNDLES } from "../utils/constants";
import { PriceRow } from "../components/Cards";

export default function Services(){
  return (
    <>
      <Section
        title="Services & Pricing"
        subtitle="Starting rates based on install difficulty. Email to confirm an exact quote and schedule."
      >
        <div className="card" style={{padding:20}}>
          {SERVICES.map(s=>(
            <PriceRow key={s.title} title={s.title} price={s.price} href={s.link}>
              {s.description}
            </PriceRow>
          ))}
          <div className="hr" style={{marginTop:16}}/>
          <p className="small muted" style={{margin:0}}>
            Install scheduling is handled by email to ensure accurate quotes and availability.
          </p>
        </div>
      </Section>

      <Section title="Bundles" subtitle="Popular combinations for maximum value.">
        <div className="card" style={{padding:20}}>
          {BUNDLES.map(b=>(
            <PriceRow key={b.title} title={b.title} price={b.price} href={b.link}>
              {b.description}
            </PriceRow>
          ))}
        </div>
      </Section>
    </>
  );
}
